import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class BodyClassService {

	private _classes = new Subject<any>();

	classes = this._classes.asObservable();

  constructor() { }

  sendClasses(list: any, add:boolean = true) {
  	let classList = document.body.classList;

  	if (list.length > 0 && typeof list != 'string') {
			list.map(o => {
				if (!classList.contains(o) && add) { 
					classList.add(o);
				} else if (classList.contains(o) && !add) { 
					classList.remove(o);
				}
			})
  	} else {
  		if (!classList.contains(list) && add) { 
				classList.add(list);
			} else if (classList.contains(list) && !add) { 
				classList.remove(list);
			}
  	}
  }
}


// WEBPACK FOOTER //
// ./src/app/vqutils/body-class.service.ts